// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__zIhrL","navbar":"Admin_navbar__j4kHc","content":"Admin_content__D4n-6"};